module.exports = __webpack_public_path__ + "img/intro-screen-help-female.be8b8a05.png";